import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ContainerResolver } from "./resolvers/container.resolver";
import { GroupComponent } from "./shared/group/group.component";
import { SwaggerComponent } from "./shared/swagger/swagger.component";
import { AuthGuard } from "guards/authGuard";

export enum MOSAR_URL {
  SCENARIO_MANAGER = "scenariomanager",
  SYSTEM_PROOF = "systemproof",
  FRAME_OF_REFERENCE = "frameofreference",
}

const routes: Routes = [
  {
    path: "",
    redirectTo: MOSAR_URL.SCENARIO_MANAGER,
    pathMatch: "full",
  },
  {
    path: "swagger/:apiRef",
    component: SwaggerComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "group/:groupId",
    component: GroupComponent,
    canActivate: [AuthGuard],
  },
  {
    path: MOSAR_URL.SCENARIO_MANAGER,
    canActivate: [AuthGuard],
    resolve: {
      containerData: ContainerResolver,
    },
    loadChildren: () =>
      import("./scenario/scenario.module").then((m) => m.ScenarioModule),
  },
  {
    path: MOSAR_URL.FRAME_OF_REFERENCE,
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./collection/collection.module").then((m) => m.CollectionModule),
  },
  {
    path: MOSAR_URL.SYSTEM_PROOF,
    canActivate: [AuthGuard],
    resolve: {
      containerData: ContainerResolver,
    },
    loadChildren: () =>
      import("./system-proof/system-proof.module").then(
        (m) => m.SystemProofModule
      ),
  },
  {
    path: "**",
    redirectTo: "",
    pathMatch: "full",
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: "enabled",
      onSameUrlNavigation: "reload",
    }),
  ],
  exports: [RouterModule],
  declarations: [],
})
export class AppRoutingModule {}
